<template>
  <div class="card-ticket-module">
    <div class="cardList">
      <el-menu default-active="/home/card-ticket-hxoff" class="card-menu" mode="horizontal" @select="handleSelect">
        <el-menu-item index="/home/card-ticket-module">卡券模板</el-menu-item>
        <el-menu-item index="/home/card-ticket-grantDetails">发放明细</el-menu-item>
        <el-menu-item index="/home/card-ticket-hxoff">核销明细</el-menu-item>
      </el-menu>
    </div>
    <div class="sxList">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-flod-content search-content search-input-group common-search-formtype" style="padding: 0;border: none">
          <el-form :inline="true" :model="selectList" class="search-content-item">
            <el-form-item label="券码：">
              <el-input clearable @keyup.enter.native="searchData" v-model.trim="selectList.code" placeholder="请输入券码"></el-input>
            </el-form-item>
            <el-form-item label="模板名称：">
              <el-input clearable @keyup.enter.native="searchData" v-model.trim="selectList.templateName" placeholder="请输入模板名称"></el-input>
            </el-form-item>
            <el-form-item label="卡券类型：">
              <el-select filterable v-model="selectList.ticketType" placeholder="请选择卡券类型">
                <el-option v-for="item in cardticketType" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="持有人/openid：">
              <el-input clearable @keyup.enter.native="searchData" v-model.trim="selectList.person" placeholder="请输入昵称/openid"></el-input>
            </el-form-item>
            <el-form-item label="发券系统：">
              <el-select filterable v-model="systemName" placeholder="请选择发券系统">
                <el-option v-for="item in systems" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="djList">
              <el-form-item label="核销时间：">
                <el-date-picker v-model="receiveTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="timeFormat">
                </el-date-picker>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <div class="cardTicketModule-list-tltle">
      <el-row class="" style="padding-right:0;padding-left:20px">
        <el-col :span="4" style="text-align: left;">
          <i class="el-icon-document" style="font-weight: bold;"></i>
          <span class="order-list-search-span">核销列表</span>
        </el-col>
        <el-col :span="20" class="text-align-right">
          <el-button type="primary" v-show="btnType.export" @click="addOfflineAcivityAction" class="add-btn btn-right" style="float: right;">导出</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="cardTicketModule-list">
      <el-table class="cardTicketModule-table" :data="tableData" border v-loading="loading">
        <el-table-column prop="code" label="券码" width="180">
        </el-table-column>
        <el-table-column prop="templateName" label="模板名称" width="150">
        </el-table-column>
        <el-table-column label="卡券类型" width="130">
          <template slot-scope="scope">
            <div v-if="scope.row.ticketType == 1">实物兑换券</div>
            <div v-if="scope.row.ticketType == 2">活动券</div>
            <div v-if="scope.row.ticketType == 3">代金券</div>
          </template>
        </el-table-column>
        <el-table-column prop="grantSystemName" label="发券系统" width="110">
        </el-table-column>
        <el-table-column prop="holderModelName" label="受众类型" width="100">
        </el-table-column>
        <el-table-column prop="holder" label="持有人" width="100">
        </el-table-column>
        <el-table-column prop="openid" label="openid" width="180">
        </el-table-column>
        <el-table-column prop="receiveTimeStr" :sortable="isSort" label="领券时间" width="180">
        </el-table-column>
        <el-table-column prop="verifiedTimeStr" :sortable="isSort" label="核销时间" width="180">
        </el-table-column>
        <el-table-column prop="vouchersAmount" label="面值(元)" :sortable="isSort" width="120">
        </el-table-column>
        <el-table-column prop="verifierSystemName" label="核销系统" width="110">
        </el-table-column>
        <el-table-column prop="verifier" label="核销操作人" width="160">
        </el-table-column>
        <el-table-column prop="commodityName" label="兑换产品" width="170">
        </el-table-column>
        <el-table-column prop="commodityInterCode" label="瓶盖内码" width="170">
        </el-table-column>
      </el-table>
      <div class="cardTicket-page">
        <el-pagination class="cardTicket-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="params.limit" :current-page="params.page" layout="total, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { verifiedList, verifiedExport, grantSystemList, verifiedExports } from '@/api/cardTicket.js'
import { CAR_TICKET_TYPE } from './constant'
import { butonsList,getMenId } from '@/api/analyse.js'
export default {
  name: 'cardTicketHxoff',
  data () {
    return {
      hide: true,
      selectList: {},
      receiveTime: [],
      systemName: '',
      systems: [],
      timePickerDate: '',
      params: {
        code: '',
        templateName: '',
        grantSystemCode: '',
        holder: '',
        verifiedStartTime: '',
        verifiedEndTime: '',
        page: 1,
        limit: 10,
        sortCode: '',
        sortRole: ''
      },
      cardticketType: CAR_TICKET_TYPE,
      tableData: [],
      isSort: true,
      limit: 10,//每页显示的条数
      page: 1,//当前页数
      totalCount: 0,//总条目数
      vueRoute: '',
      loading: true,
      btnType:{
        'export':false
      }
    }
  },
  methods: {
    // 查询发放系统
    grantSystemList () {
      grantSystemList().then(res => {
        this.systems.push({
          code: 'CLOUD_all',
          companyId: 0,
          id: 0,
          name: '全部',
          relModelId: 0,
          remark: '全部'
        })
        for (let i of res.data.result) {
          this.systems.push(i)
        }

      })
    },
    queryBtnList(){
      var itemId = getMenId(this.$route.path)
       butonsList({systemCode: 'ZY_INTELLIQUOR',menuId:38})
        .then((res)=>{
          if(res.data.code == '200'){
            var btnList = this.btnType
            for(let i = 0, k = res.data.result.length; i < k; i ++){
              for(let m in btnList){
                if(res.data.result[i].perms.indexOf(m) != -1){
                  this.btnType[m] = true
                }
              }
            }
          }
        })
    },
    searchData () {
      this.params.code = this.selectList.code
      this.params.templateName = this.selectList.templateName
      this.params.ticketType = this.selectList.ticketType
      this.params.holder = this.selectList.person
      this.params.grantSystemCode = this.systemName
      if (this.receiveTime == null) {
        this.params.verifiedStartTime = ''
        this.params.verifiedEndTime = ''
      }
      if (this.selectList.ticketType == 0) {
        this.params.ticketType = ''
      }
      if (this.systemName == 'CLOUD_all') {
        this.params.grantSystemCode = ''
      }
      this.getData()
    },
    getData () {
      this.loading = true
      verifiedList(this.params).then(res => {
        console.log(res)
        this.tableData = res.data.result.list
        this.totalCount = res.data.result.total
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 导出
    addOfflineAcivityAction () {
      verifiedExports(this.params).then(res => {
        this.download(res)
      })
    },
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 顶部菜单
    handleSelect (key, keyPath) {
      router.push(key)
    },
    timeFormat (val) {
      if (val != undefined || val != '' || val != null) {
        this.selectList.receiveTime = val
        this.params.verifiedStartTime = this.receiveTime[0]
        this.params.verifiedEndTime = this.receiveTime[1]
      } else {
        this.receiveTime = []
      }
    },
    // 处理分页
    handleSizeChange (val) {
      this.params.limit = val
    },
    handleCurrentChange (page) {
      this.params.page = page
      this.getData()
    },
  },
  mounted () {

  },
  created () {
    if (this.$route.query.ticketName && this.$route.query.templateId) {
      this.params.templateName = this.$route.query.ticketName
      this.selectList.templateName = this.$route.query.ticketName
      this.getData()
    } else {
      this.getData()
    }
    this.grantSystemList()
    this.queryBtnList()
  }
}
</script>

<style scoped>
</style>
